module.exports = __webpack_public_path__ + "img/arrowReadMore.b7174a76.svg";